export const ProfileIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" aria-hidden>
    <path
      fill="#fafffa"
      d="M12 11.7c-1 0-1.8-.4-2.5-1-.7-.7-1-1.5-1-2.5s.3-1.8 1-2.5 1.5-1 2.5-1 1.8.3 2.5 1 1 1.5 1 2.5-.3 1.8-1 2.5c-.7.6-1.5 1-2.5 1Zm-7.5 7.6v-2.2c0-.5.1-1 .4-1.4l1-1a14.5 14.5 0 0 1 6.1-1.4 13 13 0 0 1 6 1.5 2.7 2.7 0 0 1 1.5 2.3v2.2h-15ZM6 17.8h12v-.7c0-.2 0-.4-.2-.6 0-.2-.3-.3-.5-.4a12.9 12.9 0 0 0-5.3-1.3 11.4 11.4 0 0 0-5.3 1.3l-.5.4a1 1 0 0 0-.2.6v.7Zm6-7.6c.6 0 1-.2 1.4-.6.4-.4.6-.9.6-1.4 0-.6-.2-1-.6-1.4a2 2 0 0 0-1.4-.6 2 2 0 0 0-1.4.6 2 2 0 0 0-.6 1.4c0 .5.2 1 .6 1.4.4.4.8.6 1.4.6Z"
    />
  </svg>
)
